import { useCallback, useState } from 'react';
import { LayoutAnimation } from 'react-native';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setShowNotificationsWalkThrough } from 'actions/walkthrough';
import { isIOS, isWeb } from '../../../constants';
const useNotificationWalkthroughLayout = () => {
    const dispatch = useAppDispatch();
    const [notificationPosition, setNotificationPosition] = useState(null);
    const showNotificationsWalkThrough = useAppSelector((store) => store.walkthrough.showNotificationsWalkThrough);
    const hasSeenNotificationsWalkThrough = useAppSelector((store) => store.walkthrough.hasSeenNotificationsWalkThrough);
    const onLayout = useCallback(({ x, y, width, height }) => {
        if (isWeb)
            return;
        setNotificationPosition({ x, y, width, height });
        if (!hasSeenNotificationsWalkThrough && !showNotificationsWalkThrough) {
            if (isIOS) {
                LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
            }
            dispatch(setShowNotificationsWalkThrough(true));
        }
    }, [hasSeenNotificationsWalkThrough, showNotificationsWalkThrough]);
    return {
        notificationPosition,
        onLayout,
    };
};
export default useNotificationWalkthroughLayout;
